'use client';

import * as React from 'react';
import { useEffect } from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { useDialogKeyboardScroll } from '@tourtask/ui/hooks/useDialogKeyboardScroll';
import lightTheme from './lightTheme';
/* import darkTheme from './darkTheme'; */

export function ThemeRegistry({ children }: { children: React.ReactNode }) {
  // Restore Arrow / Page / Home / End scrolling inside every dialog — MUI's
  // focus trap otherwise leaves focus on a non-scrollable ancestor, so these
  // keys (which work on a normal page) do nothing inside a dialog.
  useDialogKeyboardScroll();

  useEffect(() => {
    const handler = () => {
      if (document.activeElement instanceof HTMLInputElement && document.activeElement.type === 'number') {
        document.activeElement.blur();
      }
    };
    document.addEventListener('wheel', handler, { passive: true });
    return () => document.removeEventListener('wheel', handler);
  }, []);

  return (
      <ThemeProvider theme={lightTheme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
  );
}
